import React from "react";

import Table from "components/Table";
import { orderReceiptsReturnsColumns } from "./columns";

interface IProps {
  isLoading: boolean;
  loadData: () => void;
  data: any[];
}

class OrderReceiptsReturns extends React.PureComponent<IProps> {
  public componentDidMount() {
    this.props.loadData();
  }

  public render() {
    const { isLoading, data } = this.props;

    return (
      <Table
        columns={orderReceiptsReturnsColumns}
        dataSource={data}
        isLoading={isLoading}
      />
    );
  }
}

export default OrderReceiptsReturns;
